import fetch from "@lib/fetch";
import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { linkShorteningDomainsCacheKey } from "./constants";

export const getCompanyLinkShorteningDomains = reactQueryFetcherAdapter(
  linkShorteningDomainsCacheKey,
  async (signal, companyId: string): Promise<string[]> => {
    return fetch(`/companies/${companyId}/link_shortening_domains`, "GET", undefined, { signal });
  }
);
